import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "disha_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] rise" data-testid="cookie-banner">
      <div className="bg-white border border-[#E9DFE7] shadow-2xl rounded-2xl p-5">
        <div className="flex items-start gap-3">
          <div className="h-9 w-9 shrink-0 rounded-full bg-[#F3E8F1] flex items-center justify-center"><Cookie className="h-4 w-4 text-[#4F0341]" /></div>
          <div className="space-y-1">
            <p className="font-display font-bold text-[#1C111A]">We value your privacy</p>
            <p className="text-sm text-[#635060] leading-relaxed">
              We use essential cookies to keep you signed in and secure. With your permission we would also use optional cookies to understand how the site is used. See our{" "}
              <Link to="/privacy" className="underline text-[#4F0341]" data-testid="cookie-privacy-link">privacy policy</Link>.
            </p>
          </div>
        </div>
        <div className="mt-4 flex gap-2 justify-end">
          <button onClick={() => choose("essential")} className="btn-pill h-10 border border-[#E9DFE7] text-[#1C111A] hover:bg-[#F3E8F1]" data-testid="cookie-decline-button">Essential only</button>
          <button onClick={() => choose("all")} className="btn-pill h-10 bg-[#4F0341] text-white hover:bg-[#721862]" data-testid="cookie-accept-button">Accept all</button>
        </div>
      </div>
    </div>
  );
}
